<template>
  <form @keydown="keyDown" ref="form" novalidate>
    <slot></slot>
  </form>
</template>

<script>
export default {
  mounted() {
    this.$refs.form.addEventListener('submit', this.onSubmit)
  },
  beforeDestroy() {
    this.$refs.form.removeEventListener('submit', this.onSubmit)
  },
  methods: {
    validate: function() {
      let isValid = true

      for (const node of this.$slots.default) {
        if (this.validateNode(node) !== true) {
          isValid = false
        }
      }

      return isValid
    },
    getChildren(vnode) {
      return vnode.children || (vnode.componentOptions && vnode.componentOptions.children)
    },
    validateNode(vnode) {
      if (vnode.componentInstance !== undefined && typeof vnode.componentInstance.validate !== 'undefined') {
        return vnode.componentInstance.validate()
      }

      let isValid = true

      const children = this.getChildren(vnode)
      if (children) {
        for (const child of children) {
          if (this.validateNode(child) !== true) {
            isValid = false
          }
        }
      }

      return isValid
    },
    reset: function() {
      this.$slots.default.forEach(vnode => {
        if (vnode.componentInstance !== undefined && typeof vnode.componentInstance.validate !== 'undefined') {
          vnode.componentInstance.reset()
        }
      })

      this.$emit('reset')
    },
    onSubmit: function(e) {
      if (e.preventDefault) e.preventDefault()
      this.$emit('submit')
      return false
    },
    keyDown: function(e) {
      if (
        e.keyCode === 13 &&
        e.target.tagName !== 'TEXTAREA' &&
        e.target.type !== 'password' &&
        !e.target.classList.contains('search-business__input') &&
        !e.target.classList.contains('edit-gathering__search-business-input')
      )
        e.preventDefault()
    }
  }
}
</script>
